import { Unit } from './Unit';

export interface Product {
  id?: number;

  // General
  name: string;
  sector_id?: number | null;  // Para formulario
  sector?: string;  // Para tabla (viene del backend como nombre)
  category_id?: number | null;  // Para formulario
  category?: string;  // Para tabla (viene del backend como nombre)
  ownership_type?: 'OWN' | 'OWN_THIRD_PARTY' | 'THIRD_PARTY';
  ownership_type_label?: string; // viene del backend
  origin_id?: number | null;  // Para formulario
  origin?: string;  // Para tabla (viene del backend como nombre)
  applies_cuts?: boolean;
  cuts_count?: number | null;
  quality_id?: number | null;  // Para formulario
  quality?: string;  // Para tabla (viene del backend como nombre)
  color_id?: number | null;  // Para formulario
  color?: string;  // Para tabla (viene del backend como nombre)
  stock?: number;
  unit_id?: number | null;
  unit?: Unit | string; // el list devuelve string (unit.name)

  // Venta
  sale_name?: string;
  sale_taxes?: (number | string)[];

  // Compra
  purchase_name?: string;
  purchase_taxes?: (number | string)[];

  is_active?: boolean;
}

export interface ProductFilters {
  id?: number | null;
  name?: string | '';
  sector?: string | '';  // Filtro por nombre
  category?: string | '';  // Filtro por nombre
  ownership_type?: string | '';
  origin?: string | '';  // Filtro por nombre
  quality?: string | '';
  color?: string | '';
  unit?: string | '';
  sale_name?: string | '';
  purchase_name?: string | '';
  is_active?: boolean | '';
  page: number;
  per_page: number;
  sort: string;
  order: string;
}

export type ProductDataForm = Product;

export const defaultProductDataForm: ProductDataForm = {
  name: '',
  sector_id: null,
  sector: '',
  category_id: null,
  category: '',
  ownership_type: 'OWN',
  origin_id: null,
  origin: '',
  applies_cuts: false,
  cuts_count: null,
  quality: '',
  color: '',
  stock: 0,
  unit_id: null,
  sale_name: '',
  sale_taxes: [],
  purchase_name: '',
  purchase_taxes: [],
  is_active: true,
};
